import type { ScoreRow } from '../lib/api.ts'
import { Button } from './Button.tsx'
import { ScoreRows } from './ScoreRows.tsx'

/**
 * The label and the reading, side by side, over a simulation's score.
 *
 * The table itself is `ScoreRows`, shared with the run a case screen asks for:
 * the same comparison shown in two places must not be two tables that read
 * differently about the same thing.
 */
export function ScoreDiff({ rows, onClose }: { rows: readonly ScoreRow[]; onClose: () => void }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Gabarito e leitura, lado a lado"
      onClick={onClose}
    >
      <div
        className="rounded-base bg-background-raised border-stroke-weak flex max-h-[85vh] w-full max-w-[64rem] flex-col gap-3 overflow-y-auto border p-4"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-2">
          <h2 className="text-tPSemi text-text-strong">Gabarito × leitura</h2>
          <Button variant="tertiary" tone="neutral" size="small" onClick={onClose}>
            Fechar
          </Button>
        </div>

        <ScoreRows rows={rows} />
      </div>
    </div>
  )
}
